import { _ } from '@splunk/ui-utils/i18n';
import type { PresetHOC } from '../types/PresetHOC';

/**
 * Add a property to the Item class to inform that it can set tokens based on item events
 * @param {LayoutItem} Item The item to enhance
 */
export const withSwitchToTab: PresetHOC<{
    canSwitchToTab?: boolean;
    interactionsFilterMetadata?: string[];
}> = (Item) => {
    Item.canSwitchToTab = true;
    Item.interactionsFilterMetadata ??= [];
    Item.interactionsFilterMetadata.push(_('Switch to tab'));

    return Item;
};
